import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
// Material UI
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  Snackbar,
  Step,
  StepLabel,
  Stepper,
  Switch,
  Tooltip,
  makeStyles,
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from '@material-ui/core';
//Material Icons
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AddIcon from '@material-ui/icons/Add';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
//Componentes / Helpers
import NodesContext from '../../../context/NodesContext';
import DatePickerCommon from '../../DatePicker/DatePickerCommon';
import MultiNode from '../../InstantBasic/MultiNode';
import { Alert, Pagination } from '@mui/material';
import { DATE_OPTIONS } from './helpers';
//Servicios
import { getStatusNodes } from '../../../services/meters';
import { getDiagramAlert, getListAlertPage } from '../../../services/diagrams';

let scrollsSettings = {
  overflow: 'scroll',
  height: '50vh',
  overflowX: 'hidden',
};
let webkitScrollbar = {
  background: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#beb1b18f',
  color: 'red',
  width: '9px',
};
let webkitscrollbarTrack = { background: '#dfdfe957' };

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiGrid-root': { padding: theme.spacing(1) },
    marginBottom: '10px',
  },
  devicesLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
  },
  leftSpacing: { marginLeft: theme.spacing(1) },
  hint: {
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:hover': { backgroundColor: 'rgb(54, 143, 193);' },
  },
  tick: { backgroundColor: theme.palette.success.light },
  active: { backgroundColor: theme.palette.primary.main },
  steppersFilter: {
    '@media (max-width: 920px)': { display: 'none' },
    '&.MuiStep-horizontal': { paddingLeft: 0, paddingRight: 0 },
  },
  addBtn: {
    margin: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    '&:hover': { backgroundColor: 'rgb(54, 143, 193);' },
  },
  filterChip: {
    margin: theme.spacing(0.5),
    '@media (max-width: 700px)': { width: '250px' },
  },
  dialogTitle: { '@media (max-width: 700px)': { textAlign: 'center' } },
  dialogSubtitle: {
    marginLeft: theme.spacing(3),
    color: theme.palette.primary.main,
    '@media (max-width: 700px)': { display: 'none' },
  },
  selectedItemsContainer: { display: 'flex', flexWrap: 'wrap' },
  chip: { marginTop: theme.spacing(1) },
  circular: { display: 'flex', justifyContent: 'center', marginTop: '15px' },
  label: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginLeft: '12px',
  },
  sectionTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionSubTitle: {
    color: 'rgba(0,0,0,0.54)',
    fontSize: '0.9rem',
    marginTop: theme.spacing(0.5),
  },
  filterLabel: { color: 'rgba(0,0,0,0.54)', fontSize: '0.75rem' },
  switchLabel: { fontSize: '0.85rem' },
  rowSpace: { marginBottom: theme.spacing(2) },
  btnSpacing: { margin: theme.spacing(2, 1) },
  containerNodes: {
    paddingRight: '8px',
    ...scrollsSettings,
    '&::-webkit-scrollbar': { ...webkitScrollbar },
    '&::-webkit-scrollbar-track': { ...webkitscrollbarTrack },
    '&::-webkit-scrollbar-thumb': { background: theme.palette.primary.main },
    '@media (max-width: 1100px)': { width: '100%' },
  },
  wrapperDatepicker: {
    marginTop: '10px',
    position: 'relative',
    width: '100%',
    left: '50%',
    transform: 'translate(-50%)',
    textAlign: 'center',
  },
  labelDate: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  help: {
    color: 'rgba(0,0,0,0.54)',
    fontSize: '0.85rem',
    padding: theme.spacing(0.5),
  },
  emptyState: {
    color: 'rgba(0,0,0,0.38)',
    fontSize: '0.9rem',
    marginLeft: theme.spacing(1),
  },
  separatorCol: {
    minWidth: 80,
    textAlign: 'center',
    alignSelf: 'flex-start',
    paddingTop: theme.spacing(4),
  },
  pill: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 999,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontSize: 12,
    fontWeight: 600,
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    background: theme.palette.common.white,
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0,0,0,0.08)',
    boxShadow: '0 -6px 12px -8px rgba(0,0,0,0.15)',
    zIndex: 1,
  },
}));

function Filter({ onSubmit, filterOptions, setFilterPanel }) {
  const classes = useStyles();
  const { nodes } = useContext(NodesContext);

  const [selectedNodes, setSelectedNodes] = useState([]);
  const [primaryList, setPrimaryList] = useState(
    filterOptions.dispositivos || []
  );
  const [showDevices, setShowDevices] = useState(false);

  const [filter, setFilter] = useState({
    ...filterOptions,
    dateFrom:
      filterOptions.dateFrom ?? filterOptions.alertsDateFrom ?? new Date(),
    dateTo: filterOptions.dateTo ?? filterOptions.alertsDateTo ?? new Date(),
    quickDateOption: filterOptions.quickDateOption ?? 'HOY',
  });

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'warning',
  });

  const { dateFrom, dateTo } = filter;

  const switchOptions = [
    { id: 1, label: 'Alarmas del dispositivo', optionName: 'showAlarms' },
    {
      id: 2,
      label: 'Pérdida de conectividad (dispositivo)',
      optionName: 'showConnectivityOutages',
    },
    {
      id: 4,
      label: 'Corte de energía (dispositivo)',
      optionName: 'showElectricOutages',
    },
  ];

  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    'Elija el/los dispositivos que desea graficar',
    'Elija los tipos de eventos que desea graficar',
    'Elija las alertas que desea graficar',
    'Seleccione la fecha deseada',
    'Haga click en CONSULTAR',
  ];

  const [statusNodes, setStatusNodes] = useState([]);

  // --------- ALERTAS ----------
  const [alerts, setAlerts] = useState([]);
  const [showAlertsDialog, setShowAlertsDialog] = useState(false);
  const [selectedAlerts, setSelectedAlerts] = useState(
    filterOptions.selectedAlerts || []
  );
  const [alertsList, setAlertsList] = useState(
    filterOptions.selectedAlerts || []
  );
  const [disableSelectAlerts, setDisableSelectAlerts] = useState(false);
  const [disableFilter, setDisableFilter] = useState(false);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 10;
  const [totalPages, setTotalPages] = useState(0);


  useEffect(() => {
    console.log(filter)
  }, [filter])

  useEffect(() => {
    const getStatusNodesAux = async () => {
      const res = await getStatusNodes();
      setStatusNodes(res.data);
    };
    getAlerts();
    getStatusNodesAux();
  }, []);

  const getAlerts = async (page = 1) => {
    try {
      const res = await getListAlertPage(page);
      const results = res?.data?.results
      setAlerts(results || []);
      setTotalPages(Math.ceil(res?.data?.count / PAGE_SIZE));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setFilter(prev => ({ ...prev, ...filterOptions }));
  }, [filterOptions]);

  useEffect(() => {
    let alerts = filter.selectedAlerts || [];
    let devices = filter.dispositivos || [];

    let selectedDevicesAndAlerts = [...alerts, ...devices];

    if (alerts?.length > 0) {
      setActiveStep(2);
    } else if (devices?.length > 0) {
      setActiveStep(1);
    }

    if (alerts.length >= 5) {
      setDisableSelectAlerts(true);
    } else {
      setDisableSelectAlerts(false);
    }

    if (selectedDevicesAndAlerts.length >= 10) {
      setDisableFilter(true);
    } else {
      setDisableFilter(false);
    }
  }, [filter]);

  const handleCancelFilterDialog = () => setFilterPanel(false);

  const handleFilterChange = e => {
    if (e.target.type === 'checkbox') {
      setFilter(prev => ({
        ...prev,
        [e.target.name]: JSON.parse(e.target.checked),
      }));
    }
  };

  const handleDateChange = option => {
    const startDate = new Date();
    const endDate = new Date();
    if (option === 'AYER') {
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);
    }
    if (option === 'ESTA_SEMANA') startDate.setDate(startDate.getDate() - 7);
    if (option === 'ESTE_MES') startDate.setMonth(startDate.getMonth() - 1);

    setFilter(prev => ({
      ...prev,
      dateFrom: startDate,
      dateTo: endDate,
      quickDateOption: option,
    }));
  };

  const handleSelectedNode = node => {
    setSelectedNodes(prev => {
      const idx = prev.findIndex(n => n.id === node.id);
      if (idx >= 0) return prev.filter(n => n.id !== node.id);
      return [...prev, node];
    });
  };

  const handleCloseDevices = () => setShowDevices(false);

  const handleDeleteNodeSelection = id => {
    setSelectedNodes(prev => prev.filter(n => n.id !== id));
  };

  const handleDeviceAdded = () => {
    setShowDevices(false);
    setPrimaryList(selectedNodes);
    setFilter(prev => ({ ...prev, dispositivos: selectedNodes }));
  };

  const nodeList = () =>
    nodes?.map(node => (
      <MultiNode
        node={node}
        handleSelectedNode={handleSelectedNode}
        selectedNodes={selectedNodes}
        key={node.id}
        flagComponent={'events'}
        statusNodes={statusNodes}
      />
    ));

  const handleClickedSelectionItem = () => {
    setSelectedNodes(primaryList);
    setShowDevices(true);
  };

  const handleDeleteSelectionItem = id => {
    const filteredList = primaryList.filter(item => item.id !== id);
    setPrimaryList(filteredList);
    setSelectedNodes(filteredList);
    setFilter(prev => ({ ...prev, dispositivos: filteredList }));
  };

  // --- alertas ---
  const toggleAlert = alert => {
    setSelectedAlerts(prev => {
      const exists = prev.find(a => a.id === alert.id);
      return exists ? prev.filter(a => a.id !== alert.id) : [...prev, alert];
    });
  };

  const handleAlertsAccept = () => {
    setShowAlertsDialog(false);
    setAlertsList(selectedAlerts);
    setFilter(prev => ({ ...prev, selectedAlerts }));
  };

  const handleAlertsRemoveChip = id => {
    const filtered = alertsList.filter(a => a.id !== id);
    setAlertsList(filtered);
    setSelectedAlerts(filtered);
    setFilter(prev => ({ ...prev, selectedAlerts: filtered }));
  };

  const handlePageChange = (_e, newPage) => {
    setPage(newPage);
    getAlerts(newPage);
  };

  // --- helpers UI ---
  const fmt = d =>
    d instanceof Date
      ? d.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
      : '';

  const devicesOrAlertsSelected =
    primaryList.length > 0 || alertsList.length > 0;

  return (
    <>
      <Stepper
        className={classes.steppersFilter}
        activeStep={devicesOrAlertsSelected ? 3 : 0}
        alternativeLabel
      >
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <form
        className={classes.root}
        onSubmit={e => {
          e.preventDefault();
          onSubmit(e, {
            ...filter,
            dispositivos: primaryList,
            selectedAlerts: alertsList,
          });
        }}
      >
        {/* ========== Sección 1: Selección ========== */}

        <Box display="flex" alignItems="center">
          <Tooltip
            title="Seleccione las fechas a consultar"
            arrow
            placement="right"
          >
            <Box
              className={clsx(classes.hint, classes.leftSpacing, {
                [classes.tick]: activeStep > 0,
              })}
            >
              1
            </Box>
          </Tooltip>
          <label className={classes.filterLabel}>Elegir dispositivos</label>
          <IconButton
            className={classes.addBtn}
            aria-label="Agregar dispositivos"
            onClick={() => setShowDevices(true)}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Selección de dispositivos */}
        <Box
          display="flex"
          flexDirection="column"
          flex="1 1 420px"
          minWidth={320}
        >
          {primaryList.length === 0 ? (
            <div className={classes.emptyState}>
              No hay dispositivos seleccionados
            </div>
          ) : (
            <Box mb={1}>
              {primaryList.map(node => (
                <Chip
                  key={node.id}
                  icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                  label={node.nombre}
                  clickable
                  color="primary"
                  onDelete={() => handleDeleteSelectionItem(node.id)}
                  className={classes.filterChip}
                  onClick={handleClickedSelectionItem}
                />
              ))}
            </Box>
          )}
        </Box>

        <Box display="flex" alignItems="center" mb={1}>
          <Box className={classes.devicesLabel} mt={2} ml={1}>
            Filtrar eventos de dispositivos:
          </Box>
        </Box>

        <Box display="flex" justifyContent="center">
          <FormGroup classes={{ root: classes.rowSpace }}>
            {switchOptions.map(({ id, label, optionName }) => (
              <FormControlLabel
                key={id}
                classes={{ label: classes.switchLabel }}
                control={
                  <Switch
                    checked={!!filter[optionName]}
                    onChange={handleFilterChange}
                    name={optionName}
                    color="primary"
                    disabled={primaryList.length === 0}
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>
        </Box>
        {primaryList.length === 0 && (
          <Box className={classes.help} textAlign="center">
            Seleccioná al menos <b>1 dispositivo</b> para usar estas opciones.
          </Box>
        )}

        <Divider style={{ margin: '16px 0' }} />

        {/* ========== Paso 2: Alertas ========== */}
        {/* <Box mb={2}>
          <Typography variant="h6" className={classes.sectionTitle}>
            2. Alertas
          </Typography>
          <Typography className={classes.sectionSubTitle}>
            Podés consultar también por <b>alertas</b> (además de dispositivos)
            o solo por alertas.
          </Typography>
        </Box> */}

        <Box display="flex" alignItems="center">
          <Tooltip
            title="Seleccione las fechas a consultar"
            arrow
            placement="right"
          >
            <Box
              className={clsx(classes.hint, classes.leftSpacing, {
                [classes.tick]: activeStep > 1,
              })}
            >
              2
            </Box>
          </Tooltip>
          <label className={classes.filterLabel}>Elegir alertas</label>
          <IconButton
            className={classes.addBtn}
            aria-label="Agregar alertas"
            onClick={() => {
              setSelectedAlerts(alertsList);
              setShowAlertsDialog(true);
            }}
            disabled={disableSelectAlerts}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          flex="1 1 420px"
          minWidth={320}
        >
          {alertsList.length === 0 ? (
            <div className={classes.emptyState}>
              No hay alertas seleccionadas
            </div>
          ) : (
            <Box>
              {alertsList.map(alert => (
                <Chip
                  key={alert.id}
                  icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                  label={alert.name}
                  clickable
                  color="primary"
                  onDelete={() => handleAlertsRemoveChip(alert.id)}
                  className={classes.filterChip}
                  onClick={() => {
                    setSelectedAlerts(alertsList);
                    setShowAlertsDialog(true);
                  }}
                />
              ))}
            </Box>
          )}
        </Box>

        <Divider style={{ margin: '16px 0' }} />

        {/* ========== Sección 3: Fecha y consulta ========== */}
        <Box display="flex" alignItems="center">
          <Tooltip
            title="Seleccione las fechas a consultar"
            arrow
            placement="right"
          >
            <Box
              className={clsx(classes.hint, classes.leftSpacing, {
                [classes.tick]: activeStep > 2,
              })}
            >
              3
            </Box>
          </Tooltip>
          <label className={classes.filterLabel}>
            Selecciona las fechas a consultar
          </label>
        </Box>

        <Box display="flex" flexWrap="wrap" minHeight={40} alignItems="center">
          <Box className={classes.filterLabel} mb={1} ml={1}>
            Seleccionar fecha:
          </Box>
        </Box>

        <Box display="flex" flexDirection="column" alignContent="center">
          <Box display="flex" justifyContent="center">
            <ButtonGroup
              variant="outlined"
              color="primary"
              size="small"
              aria-label="botones rápidos de fecha"
            >
              {DATE_OPTIONS.map(option => (
                <Button
                  key={option.key}
                  onClick={() => handleDateChange(option.key)}
                  variant={
                    filter.quickDateOption === option.key
                      ? 'contained'
                      : undefined
                  }
                >
                  {option.label}
                </Button>
              ))}
            </ButtonGroup>
          </Box>

          <Box className={classes.wrapperDatepicker}>
            <label className={classes.labelDate}>Desde / Hasta</label>
            <DatePickerCommon
              startDate={dateFrom}
              endDate={dateTo}
              setDate={setFilter}
            />
            <Box mt={1}>
              <span className={classes.pill}>
                {fmt(dateFrom)} — {fmt(dateTo)}
              </span>
            </Box>
          </Box>
        </Box>

        {!devicesOrAlertsSelected && (
          <Box className={classes.help} textAlign="center" mt={1}>
            Debe seleccionar al menos un <b>dispositivo</b> o una <b>alerta</b>.
          </Box>
        )}

        <Box className={classes.stickyFooter} mt={3}>
          <Box gridGap={12}>
            {disableFilter && (
              <Alert severity="warning">
                Puede obtener eventos y alertas de menos de 10 dispositivos.
              </Alert>
            )}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 700, marginBottom: 4 }}
                >
                  Resumen de consulta
                </Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  gridGap={8}
                  flexWrap="wrap"
                >
                  <span className={classes.pill}>
                    {primaryList.length} disp.
                  </span>
                  <span className={classes.pill}>
                    {alertsList.length} alertas
                  </span>
                  <span className={classes.pill}>
                    {fmt(dateFrom)} → {fmt(dateTo)}
                  </span>
                </Box>
              </Box>

              <Box display="flex" alignItems="center">
                <span>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    className={classes.btnSpacing}
                    disabled={
                      (filter?.selectedAlert?.length === 0 &&
                        filter?.dispositivos?.length === 0) ||
                      disableFilter
                    }
                    aria-label="Consultar"
                  >
                    Consultar
                  </Button>
                </span>

                <Button
                  variant="contained"
                  onClick={handleCancelFilterDialog}
                  className={classes.btnSpacing}
                  aria-label="Cancelar"
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </form>

      <Dialog
        open={showDevices}
        onClose={handleCloseDevices}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        fullWidth
      >
        <Box>
          <Snackbar
            open={notification.isOpen}
            autoHideDuration={2000}
            onClose={() => setNotification({ ...notification, isOpen: false })}
          >
            <Alert
              severity={notification.severity}
              onClose={() => setNotification(false)}
            >
              {notification.msg}
            </Alert>
          </Snackbar>

          <Box padding="8px">
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
              Selección de Dispositivo
            </DialogTitle>
            <div className={classes.dialogSubtitle}>
              Seleccionar uno o más elementos de la organización
            </div>

            <Box display="flex" className={classes.selectedItemsContainer}>
              {selectedNodes.map(node => (
                <Chip
                  className={classes.chip}
                  key={node.id}
                  icon={<AccountTreeIcon />}
                  label={node.nombre}
                  clickable
                  color="primary"
                  onDelete={() => handleDeleteNodeSelection(node.id)}
                />
              ))}
            </Box>

            <Box component="label" display="block" className={classes.label}>
              Organización
            </Box>
            <Box className={classes.containerNodes}>
              <>
                {nodes.length === 0 && (
                  <h2
                    style={{
                      textAlign: 'center',
                      fontSize: '19px',
                      color: '#2586bc',
                      paddingTop: '20px',
                    }}
                  >
                    Usted no posee ninguna localización configurada en su
                    cuenta.
                    <br />
                    Por favor, configure al menos una localización para poder
                    continuar.
                    <NavLink to={`/configuracion-organizacion`}>[link]</NavLink>
                  </h2>
                )}
                <List component="div" disablePadding dense>
                  {nodeList()}
                </List>
              </>
            </Box>

            <Box display="flex" justifyContent="center">
              <Button
                className={classes.btnSpacing}
                variant="contained"
                color="primary"
                onClick={handleDeviceAdded}
                disabled={selectedNodes.length === 0}
                aria-label="Aceptar dispositivos seleccionados"
              >
                Aceptar
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDevices}
                className={classes.btnSpacing}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={showAlertsDialog}
        onClose={() => {
          setShowAlertsDialog(false);
          setSelectedAlerts(alertsList);
        }}
        aria-labelledby="alerts-dialog"
        maxWidth="sm"
        fullWidth
      >
        <Box padding="8px">
          <DialogTitle id="alerts-dialog" className={classes.dialogTitle}>
            Selección de Alertas
          </DialogTitle>
          <div className={classes.dialogSubtitle}>
            Seleccionar una o más alertas
          </div>

          <Box
            display="flex"
            ml={1}
            mb={1}
            className={classes.selectedItemsContainer}
          >
            {selectedAlerts.map(a => (
              <Chip
                className={classes.chip}
                key={a.id}
                icon={<LabelImportantIcon />}
                label={a.name}
                clickable
                style={{ marginRight: '8px' }}
                color="primary"
                onDelete={() => toggleAlert(a)}
              />
            ))}
          </Box>

          <Box component="label" display="block" className={classes.label}>
            Alertas disponibles
          </Box>
          <Box className={classes.containerNodes}>
            <List dense>
              {alerts.length === 0 && <p>No hay alertas disponibles</p>}
              {alerts.map(a => {
                const checked = !!selectedAlerts.find(x => x.id === a.id);
                return (
                  <ListItem key={a.id} button onClick={() => toggleAlert(a)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        checked={checked}
                        color="primary"
                      />
                    </ListItemIcon>
                    <ListItemText primary={a.name} />
                  </ListItem>
                );
              })}
            </List>
          </Box>

          {totalPages > 1 && (
            <Box mt={1} display="flex" justifyContent="center">
              <Pagination
                page={page}
                count={totalPages}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
              />
            </Box>
          )}

          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.btnSpacing}
              onClick={handleAlertsAccept}
              disabled={selectedAlerts.length === 0}
              aria-label="Aceptar alertas seleccionadas"
            >
              Aceptar
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setSelectedAlerts(alertsList);
                setShowAlertsDialog(false);
              }}
              className={classes.btnSpacing}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default Filter;
